import React from 'react';
import type { ArchivedPlans } from '@atlassian/jira-spa-apps-archived-plans/src/index.tsx';
import { markAsProductBundleReady } from '@atlassian/jira-spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@atlassian/jira-spa/src/view/lazy-page/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

export const LazyArchivedPlans = lazyForPaint<typeof ArchivedPlans>(() =>
	markAsProductBundleReady(
		import(
			/* webpackChunkName: "async-archived-plans", jiraSpaEntry: "async-archived-plans" */ '@atlassian/jira-spa-apps-archived-plans'
		).then((module) => module.ArchivedPlans),
	),
);

export const ArchivedPlansDirectory = (): React.JSX.Element => (
	<LazyPage Page={LazyArchivedPlans} pageId="archived-plans" shouldShowSpinner />
);
